module.exports = __webpack_public_path__ + "img/18f.4cf8fa16.png";